module.exports = __webpack_public_path__ + "static/media/share_screen.6e64181c.svg";